import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, useTheme, IconButton } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import CloseIcon from "@mui/icons-material/Close";
import useSnackBar from "../../Redux/hooks/useSnackBar";

const useStyles = makeStyles()((theme) => {
    return {
        dropText: {
            // fontSize: "16px",
            fontWeight: 500,
            [theme.breakpoints.down("md")]: {
                fontSize: "14px",
            },
        },
        avatar: {
            height: "42px",
            width: "42px",
            objectFit: "cover",
            borderRadius: "50%",
        },
    };
});
const CommonFileUpload = ({
    handleImageChange,
    sx,
    value,
    id,
    fileType,
    accept,
    isMultiple,
    handleImgClose,
    values,
    padding,
    setFieldValue,
    handleSingleDelete,
    isArray,
    error, // Add error prop for displaying error messages
    borderColor,
    flexDirection,
    background,
    border,
    ml,
    title,
    fontSize,
    imgHeight,
    imgWidth,
    disabled,
    display,
    height
}) => {
    const theme = useTheme();
    const { setSnackBar } = useSnackBar();
    const { classes } = useStyles();
    const [dragging, setDragging] = useState(false);
    const [fileName, setFileName] = useState("");

    const handleDragEnter = (e) => {
        e.preventDefault();
        setDragging(true);
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragging(false);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const file = e.dataTransfer.files;
        handleFileChange(file);
    };
    const handleFileInput = (e) => {
        const file = e.target.files;
        handleFileChange(file);
        e.target.value = "";
    };
    const handleFileChange = (files) => {
        const acceptedExtensions = accept.split(",").map((type) => type.trim().replace(".", "").toLowerCase());
        let invalidFileTypes = [];
        let oversizedFiles = [];

        for (let i = 0; i < files.length; i++) {
            const fileExtension = files[i].name.split(".").pop().toLowerCase();

            if (files[i].size > 10 * 1024 * 1024) {
                oversizedFiles.push(`${files[i].name} exceeds the maximum file size of 10MB.`);
            } else if (!acceptedExtensions.includes(fileExtension)) {
                invalidFileTypes.push(files[i].name);
            }
        }
        if (oversizedFiles.length > 0) {
            setSnackBar("error", "File size should not exceed 10 MB.");
            console.error("Oversized files:", oversizedFiles);
        } else if (invalidFileTypes.length > 0) {
            setSnackBar("error", `Invalid file type: ${invalidFileTypes.join(", ")}`);
            console.error("Invalid file types:", invalidFileTypes);
        } else {
            handleImageChange(files, id);
            setFileName(files);
        }
    };
    return (
        <>
            <Box
                sx={{
                    ...sx,
                    position: "relative",
                    border: border || `2px dashed ${dragging ? "blue" : borderColor || "#D0D0D0"}`,
                    borderRadius: "8px",
                    display: display || "flex",
                    // flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: disabled ? "default" : !value && "grab",
                    // padding: padding ? padding : { xs: "2rem", sm: "4rem", md: "5rem" },
                    padding: padding || "25px",
                    // flexDirection:"row",
                    background: disabled ? "#FAFAFA" : background,
                    height: height || "60px"

                }}
                {...(!value && {
                    onDragOver: (e) => e.preventDefault(),
                    onDragEnter: handleDragEnter,
                    onDragLeave: handleDragLeave,
                    onDrop: handleDrop,
                    onClick: () => document.getElementById(`${id}-fileInput`).click(),
                })}
            >
                {/* Drag-and-Drop Area */}
                {value ? (
                    isMultiple ? (
                        Array.isArray(value) && value.length > 0 && (
                            value.map((img, i) => (
                                <Grid container key={i}>
                                </Grid>
                            ))
                        )
                    ) : (
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography
                                fontSize={"16px"}
                                fontWeight={"400"}
                                sx={{ wordBreak: "break-word", overflowWrap: "break-word" }}
                            >
                                {value?.name || value?.split("/").pop() || "Unnamed File"}
                            </Typography>
                            <IconButton
                                color="default"
                                size="medium"
                                sx={{
                                    bgcolor: "#F5F9FB",
                                    color: (theme) => theme.palette.bgBlack.main
                                }}
                            >
                                <CloseIcon
                                    color="error"
                                    sx={{ cursor: "pointer", fontSize: "18px" }}
                                    onClick={handleSingleDelete}
                                />
                            </IconButton>
                        </Box>
                    )
                ) : (
                    <Box justifyContent="center" display="flex" alignItems="center" flexDirection={"column"} gap={1}>
                        <img
                            src={"/assets/img/uploadIcon.svg"}
                            alt="upload"
                            height={imgHeight || "21px"}
                            width={imgWidth || "21px"}
                        />
                        <Typography
                            sx={{ color: "#828282", ml: "10px", fontSize: fontSize || "16px" }}
                            className={classes.dropText}
                        >
                            {title || "Upload Your Document Here"}
                        </Typography>
                    </Box>
                )}

                <input
                    id={`${id}-fileInput`}
                    type="file"
                    accept={accept}
                    multiple={isMultiple}
                    style={{ display: "none" }}
                    onChange={handleFileInput}
                    disabled={disabled}
                />
            </Box>


            {/* Display error message */}
            {error && (
                <Typography sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                    {error}
                </Typography>
            )}
        </>
    );
};
export default CommonFileUpload;
